import { TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from "@mui/lab"
import { Typography, Divider } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { Stack } from "@mui/system"

import { useDateTime } from "../../localization/useDateTime"
import { RoadmapImplementationType, RoadmapItem } from "../newsTypes"

const useStyles = makeStyles<{ isActive: boolean }>()((theme, { isActive }) => ({
    timelineItem: {
        cursor: "pointer",
    },
    timelineContent: {
        padding: "1rem",
        marginLeft: "1rem",
        backgroundColor: isActive ? "#EEEEEE" : "transparent",
        borderBottom: !isActive ? `1px solid ${theme.palette.divider}` : "none",
    },
    date: {
        color: theme.palette.text.secondary,
        fontSize: "0.75rem",
        marginBottom: theme.spacing(0.5),
    },
    title: {
        fontSize: "0.875rem",
        fontWeight: 500,
        color: theme.palette.text.primary,
        lineHeight: 1.4,
    },
    divider: {
        height: "1.25rem",
        backgroundColor: theme.palette.divider,
    },
    type: {
        fontSize: "0.75rem",
        fontWeight: 700,
        lineHeight: 1.6,
        color: theme.palette.tailwind.green[800],
        textTransform: "capitalize",
    },
}))

interface RoadmapTimelineItemProps {
    item: RoadmapItem
    isLast?: boolean
    isActive: boolean
    isUser?: boolean
    onClick?: () => void
}

export function RoadmapTimelineItem({ item, isLast, isUser, isActive, onClick }: RoadmapTimelineItemProps) {
    const { classes } = useStyles({ isActive })
    const dateTimeFactory = useDateTime()

    const formattedDate = dateTimeFactory.formatDate(dateTimeFactory.fromApi(item.publishDate))
    const hideType = item.roadmapDetails.implementationType === RoadmapImplementationType.FEATURE && isUser

    return (
        <TimelineItem className={classes.timelineItem} onClick={onClick}>
            <TimelineSeparator>
                <TimelineDot
                    sx={{
                        margin: 0,
                    }}
                    variant={isActive ? "filled" : "outlined"}
                />
                {!isLast && <TimelineConnector />}
            </TimelineSeparator>
            <TimelineContent className={classes.timelineContent}>
                <Stack direction="row" alignItems="center" gap={1} mb={0.5}>
                    <Typography className={classes.date}>{formattedDate}</Typography>
                    {hideType ? null : (
                        <>
                            <Divider orientation="vertical" className={classes.divider} />
                            <Typography className={classes.type}>
                                {item.roadmapDetails.implementationType.toLowerCase()}
                            </Typography>
                        </>
                    )}
                </Stack>
                <Typography className={classes.title}>{item.subject}</Typography>
            </TimelineContent>
        </TimelineItem>
    )
}
